import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: 'input[autocompleteOff]'
})
export class AutocompleteOffDirective implements OnInit {

  constructor(private elementRef: ElementRef, private renderer: Renderer2) { }

  ngOnInit(): void {
    this.renderer.setAttribute(this.elementRef.nativeElement, 'autocomplete', 'off');
  }
}
